var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowRight = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.0304 5.96964C17.7375 5.67675 17.2626 5.67675 16.9697 5.96964C16.6768 6.26253 16.6768 6.73741 16.9697 7.0303L21.1894 11.25H1.5C1.08579 11.25 0.75 11.5858 0.75 12C0.75 12.4142 1.08579 12.75 1.5 12.75H21.1893L16.9697 16.9696C16.6768 17.2625 16.6768 17.7374 16.9697 18.0303C17.2626 18.3232 17.7375 18.3232 18.0304 18.0303L23.5304 12.5303C23.8233 12.2374 23.8233 11.7625 23.5304 11.4696L18.0304 5.96964Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-right.5409af10afcb371d102d55b25bb1db4a.svg";